/*
 * Copyright (c) Funtip GbR 2017.
 * Simon Oldeboershuis, Perry Prust
 */

import * as React from 'react';
import { Button } from 'reactstrap';
import CursorLeft from '../../../../icons/CursorLeft';
import CursorRight from '../../../../icons/CursorRight';
import { TournamentRound } from '../../../../services/betting';

interface NodeGridHeadingProps {
    childRounds: TournamentRound[];
    startColumn: number;
    columnCount: number;
    leftEnabled: boolean;
    rightEnabled: boolean;
    onColumnLeft: () => void;
    onColumnRight: () => void;
}

export const NodeGridHeading: React.FC<NodeGridHeadingProps> = (props) => {
    const renderTournamentRound = (tr: TournamentRound) => {
        return (
            <th className="border-right text-center" key={tr.id}>
                {tr.name}
            </th>
        );
    };

    if (props.childRounds) {
        return (
            <tr>
                <th />
                <th className="align-middle text-end border-right">
                    <Button className="btn-r1gray btn-sm" onClick={props.onColumnLeft} disabled={!props.leftEnabled}>
                        <CursorLeft />
                    </Button>
                </th>
                {props.childRounds.map((tr, index) => {
                    if (index >= props.startColumn && index < props.startColumn + props.columnCount) {
                        return renderTournamentRound(tr);
                    }
                    return null;
                })}
                <th className="align-middle">
                    <Button className="btn-r1gray btn-sm" onClick={props.onColumnRight} disabled={!props.rightEnabled}>
                        <CursorRight />
                    </Button>
                </th>
            </tr>
        );
    } else {
        return <tr />;
    }
};
